import { type RichiestaPubblicaDto } from '@framework/api-client/api/inquiries-compile/schemas/richiestaPubblicaDto.ts';
import { type RichiestaPubblicaDtoRichiesta } from '@framework/api-client/api/inquiries-compile/schemas/richiestaPubblicaDtoRichiesta.ts';
import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { DividerTitleElement } from '@framework/ui/components/text/DividerTitleElement.tsx';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { DescriptionItem } from './DescriptionItem.tsx';

export interface IProcedureDataViewProps {
  submission?: RichiestaPubblicaDtoRichiesta;
  osservation?: RichiestaPubblicaDto;
}

/**
 * ...
 */
export function ProcedureDataView(props: IProcedureDataViewProps) {
  const { submission, osservation } = props;
  const { t } = useTranslation();

  if (!submission) return null;

  return (
    <div>
      <DividerTitleElement
        title={t('observation.dati-del-procedimento', 'Dati del Procedimento')}
        removeTopMargin
      />
      <Row>
        <Col span={12}>
          {submission?.oggetto && (
            <DescriptionItem
              label={t('observation.procedimento', 'Procedimento')}
              value={submission?.oggetto ?? '–'}
            />
          )}
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t('observation.numero-protocollo', 'Numero Protocollo')}
            value={submission?.numeroProtocollo ?? '–'}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t('observation.data-protocollo', 'Data Protocollo')}
            value={
              submission?.dataProtocollo ? (
                <ISODate date={submission?.dataProtocollo ?? '–'} />
              ) : (
                '–'
              )
            }
          />
        </Col>
      </Row>
      <VerticalSpace size={12} />
      <Row>
        <Col span={12}>
          <DescriptionItem
            label={t(
              'observation.ufficio-responsabile',
              'Ufficio Responsabile',
            )}
            value={osservation?.ufficioResponsabile?.denominazione ?? '–'}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t('observation.inizio-osservazione', 'Inizio Osservazione')}
            value={<ISODate date={osservation?.dataInizioOsservazione} />}
          />
        </Col>
        <Col span={6}>
          <DescriptionItem
            label={t('observation.fine-osservazione', 'Fine Osservazione')}
            value={<ISODate date={osservation?.dataFineOsservazione} />}
          />
        </Col>
      </Row>
    </div>
  );
}
